<template>
  <div>
    <div class="main-sidebar-container" :class="{ expanded: toggleMainSidebar }">
      <div class="sidebar">
        <!-- Logo Section -->
        <div class="logo-section">
          <img v-if="toggleMainSidebar" src="@/assets/img/product/core-mix-color-hd.png" alt="Core Logo" class="img-fluid px-2" />
          <img v-else src="@/assets/img/favicon.png" alt="Vertex Logo" class="logo-img" />
        </div>

        <!-- Navigation Menu -->
        <div class="nav-menu-wrapper">
          <ul class="nav-menu-list">
            <li class="nav-menu-item" v-show="
							this.$store.state.auth.isSuperAdmin ||
							(orgAdmin || coreAdmin) && hasTraining ||
							(this.$store.state.auth.isSuperAdmin || $helper.isVertexAnalyst()) ||
							this.$store.state.auth.isManager
						">
              <router-link :to="{ name: 'Dashboard' }" class="nav-menu-link" active-class="active"
                @mouseover="showThoughtBubble($event, 'Dashboard')" @mouseout="hideThoughtBubble">
                <span class="menu-icon">
                  <dashboard-icon />
                </span>
                <span class="menu-label">Dashboard</span>
              </router-link>
            </li>
            <li class="nav-menu-item" v-show="this.$store.state.auth.isSuperAdmin || hasTraining || $helper.isVertexAnalyst()">
              <div @click="toggleTrainingSubMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link" :class="{ active: isTrainingActive }"
                  @mouseover="showThoughtBubble($event, 'Training')" @mouseout="hideThoughtBubble">
                  <span class="menu-icon">
                    <training-icon />
                  </span>
                  <span class="menu-label">Training</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: trainingSubMenuOpen }"><svg
                    xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg></span>
              </div>
              <transition name="submenu-animation">
                <ul class="submenu" v-if="trainingSubMenuOpen">
                  <li class="submenu-item" v-if="!this.$store.state.auth.isSuperAdmin">
                    <router-link :to="{ name: 'AssignedTraining' }" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Assigned Training')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <assigned-training-icon />
                      </span>
                      <span class="menu-label">Assigned Training</span>
                    </router-link>
                  </li>
                  <li class="submenu-item" v-if="!this.$store.state.auth.isSuperAdmin">
                    <router-link :to="{ name: 'CompletedTraining' }" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Completed Training')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <completed-training-icon />
                      </span>
                      <span class="menu-label">Completed Training</span></router-link>
                  </li>
                  <li class="submenu-item" v-if="this.$store.state.auth.isSuperAdmin || isTrainingAdmin || orgAdmin">
                    <router-link :to="{ name: 'UserLibrarySettings' }" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Settings')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <training-settings-icon />
                      </span>
                      <span class="menu-label">Settings</span></router-link></li>
                </ul>
              </transition>
            </li>
            <li class="nav-menu-item" v-show="this.$store.state.auth.isSuperAdmin || hasPolicy">
              <div @click="togglePoliciesSubMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link" :class="{ active: isPoliciesActive }"
                  @mouseover="showThoughtBubble($event, 'Policies')" @mouseout="hideThoughtBubble">
                  <span class="menu-icon">
                    <policies-icon />
                  </span>
                  <span class="menu-label">Policies</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: policiesSubMenuOpen }"><svg
                    xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg></span>
              </div>
              <transition name="submenu-animation">
                <ul class="submenu" v-if="policiesSubMenuOpen">
                  <li class="submenu-item">
                    <router-link to="/policy/compliance" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Policy Compliance')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <policy-compliance-icon />
                      </span>
                      <span class="menu-label">Policy Compliance</span></router-link>
                  </li>
                  <li class="submenu-item"
                    v-if="this.$store.state.auth.isSuperAdmin || orgAdmin || isPolicyOwner || isPolicyAdmin">
                    <router-link to="/policy/library" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Policy Library')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <policy-library-icon />
                      </span>
                      <span class="menu-label">Policy Library</span></router-link>
                  </li>
                </ul>
              </transition>
            </li>
            <li class="nav-menu-item" v-show="this.$store.state.auth.isSuperAdmin || (orgAdmin || coreAdmin) && hasPhishing">
              <router-link to="/phishing" class="nav-menu-link" active-class="active"
                @mouseover="showThoughtBubble($event, 'Phishing')" @mouseout="hideThoughtBubble">
                <span class="menu-icon">
                  <phishing-icon />
                </span>
                <span class="menu-label">Phishing</span>
              </router-link>
            </li>
            <li class="nav-menu-item" v-show="$store.state.auth.isSuperAdmin">
              <div @click="toggleReportingSubMenu" class="nav-menu-link-container">
                <a href="#" @click.prevent class="nav-menu-link" :class="{ active: isAdminSettingsActive }"
                  @mouseover="showThoughtBubble($event, 'Settings')" @mouseout="hideThoughtBubble">
                  <span class="menu-icon">
                    <settings-icon />
                  </span>
                  <span class="menu-label">Settings</span>
                </a>
                <span class="submenu-arrow" :class="{ rotated: reportingSubMenuOpen }"><svg
                    xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg></span>
              </div>
              <transition name="submenu-animation">
                <ul class="submenu" v-if="reportingSubMenuOpen">
                  <li class="submenu-item">
                    <router-link to="/admin/settings/scheduled-jobs" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Scheduled Jobs')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <scheduled-job-icon />
                      </span>
                      <span class="menu-label">Scheduled Jobs</span>
                    </router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/admin/settings/training-library" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Training Library')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <training-library-icon />
                      </span>
                      <span class="menu-label">Training Library</span>
                    </router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/admin/settings/phishing-configuration" class="submenu-link" active-class="active"
                      @mouseover="showThoughtBubble($event, 'Phishing Configuration')" @mouseout="hideThoughtBubble">
                      <span class="menu-icon">
                        <phishing-configuration-icon />
                      </span>
                      <span class="menu-label">Phishing Configuration</span>
                    </router-link>
                  </li>
                </ul>
              </transition>
            </li>
          </ul>
        </div>

        <!-- Organisation Dropdown -->
        <div class="org-dropdown-container">
          <div class="org-info-wrapper" @click="toggleOrgDropdown">
            <div class="org-info" :class="{ 'non-interactive': !($store.state.auth.isSuperAdmin || ($helper.isVertexAnalyst() && isDashboardPage)) }">
              <div class="org-logo">
                <img :src="organisationLogo" alt="Organisation Logo" />
              </div>
              <div class="org-name" :title="organisationName">
                {{ organisationName }}
              </div>
            </div>
          </div>
        </div>

        <!-- Account Menu -->
        <div class="user-dropdown-container">
          <div class="account-menu-wrapper" @click="toggleUserDropdown">
            <div class="user-info">
              <div class="user-avatar">
                {{ user.first_name ? user.first_name.charAt(0) : ""
                }}{{ user.last_name ? user.last_name.charAt(0) : "" }}
              </div>
              <div class="user-name">
                {{ user.first_name }} {{ user.last_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-bar" :class="{ expanded: toggleMainSidebar }">
      <button class="toggle-menu-btn" @click="toggleSidebar">
        <div class="hamburger-icon">
          <svg v-if="!toggleMainSidebar" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </div>
      </button>
    </div>

    <div class="org-dropdown" v-if="orgDropdownOpen">
      <div class="search-bar">
        <input ref="orgSearchInput" type="text" v-model="orgSearchTerm" placeholder="Search organisations..." />
      </div>
      <ul class="org-list">
        <li v-for="org in filteredOrganisations" :key="org.id" @click="selectOrganisation(org)"
          @mouseover="showTooltipIfTruncated">
          {{ org.name }}
        </li>
      </ul>
    </div>

    <div class="user-dropdown" v-if="userDropdownOpen">
      <ul class="user-menu-list">
        <li v-show="$store.state.auth.isSuperAdmin || $store.state.user.organisation.is_organisation_admin"
          @click="orgSettings">
          Organisation Settings
        </li>
        <li @click="profileURL">User Settings</li>
        <li @click="logout">Logout</li>
      </ul>
    </div>

    <!-- Backdrop for mobile -->
    <div class="sidebar-backdrop" :class="{ active: isBackdropActive }" @click="closeSidebar"></div>
    <thought-bubble :visible="thoughtBubble.visible" :content="thoughtBubble.content"
      :position="thoughtBubble.position" />
  </div>
</template>

<script>
import DashboardIcon from "@/components/icons/DashboardIcon.vue";
import TrainingIcon from "@/components/icons/TrainingIcon.vue";
import PoliciesIcon from "@/components/icons/PoliciesIcon.vue";
import PhishingIcon from "@/components/icons/PhishingIcon.vue";
import SettingsIcon from "@/components/icons/SettingsIcon.vue";
import AssignedTrainingIcon from "@/components/icons/AssignedTrainingIcon.vue";
import CompletedTrainingIcon from "@/components/icons/CompletedTrainingIcon.vue";
import TrainingSettingsIcon from "@/components/icons/TrainingSettingsIcon.vue";
import PolicyComplianceIcon from "@/components/icons/PolicyComplianceIcon.vue";
import PolicyLibraryIcon from "@/components/icons/PolicyLibraryIcon.vue";
import PhishingConfigurationIcon from "@/components/icons/PhishingConfigurationIcon.vue";
import ScheduledJobIcon from "@/components/icons/ScheduledJobIcon.vue";
import TrainingLibraryIcon from "@/components/icons/TrainingLibraryIcon.vue";
import defaultLogo from "@/assets/img/favicon.png";
import ThoughtBubble from "./ThoughtBubble.vue";

export default {
  components: {
    DashboardIcon,
    TrainingIcon,
    PhishingIcon,
    PoliciesIcon,
    SettingsIcon,
    AssignedTrainingIcon,
    CompletedTrainingIcon,
    TrainingSettingsIcon,
    PolicyComplianceIcon,
    PolicyLibraryIcon,
    PhishingConfigurationIcon,
    TrainingLibraryIcon,
    ScheduledJobIcon,
    ThoughtBubble,
  },
  data() {
    return {
      isSuperAdmin: false,
      isOrgAdmin: false,
      toggleMainSidebar: false,
      isSidebarManuallyToggled: false,
      user: {
        first_name: this.$store.state.auth.jwtPayload.first_name,
        last_name: this.$store.state.auth.jwtPayload.last_name
      },
      organisationsList: null,
      searchTerm: "",
      defaultLogo,
      isBackdropActive: false,
      reportingSubMenuOpen: false, // Add this line
      trainingSubMenuOpen: false,
      policiesSubMenuOpen: false,
      orgDropdownOpen: false,
      orgSearchTerm: "",
      userDropdownOpen: false,
      thoughtBubble: {
        visible: false,
        content: "",
        position: {},
      },
      orgAdmin: this.$store.state.auth.isOrganisationAdmin,
      coreAdmin: this.$store.state.auth.isCoreAdmin,
      isPolicyAdmin: this.$store.state.auth.isPolicyAdmin,
      isTrainingAdmin: this.$store.state.auth.isTrainingAdmin,
      dialog: false,
      hasTraining: false,
      hasPhishing: false,
      hasPentest: false,
      hasPolicy: false,
    };
  },

  async mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize(); // Call on mount to set initial state
    document.addEventListener("click", this.handleClickOutside);

    if (this.$helper.isVertexAnalyst() && !this.isDashboardPage) {
      let analystOrg = null;
      try {
        const organisationString = localStorage.getItem('userOrganisation');
        analystOrg = organisationString ? JSON.parse(organisationString) : null;
      } catch (e) {
        analystOrg = null;
      }
      const targetId = analystOrg?.id || this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation_id;
      if (targetId && this.organisationID != targetId) {
        this.setDefaultOrganisation();
      }
    }

    if (!this.$store.state.auth.isSuperAdmin) {

      this.trainingAdmin()
      this.settingsAdmin()

      if (!this.$store.state.auth.isOrganisationAdmin && !this.$store.state.auth.isPolicyAdmin)
        await this.$store.dispatch('user/determinePolicyOwner');
    }

  },

  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
    document.removeEventListener("click", this.handleClickOutside);
  },

  computed: {
    organisationID() {
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation?.id : this.$store.state.user.organisation?.organisation_id;
    },
    isOrgSettingsActive() {
      return this.$route.path.startsWith("/organisations");
    },
    isReportingActive() {
      return this.$route.path.startsWith("/reporting");
    },
    isTrainingActive() {
      return false;
    },
    isPoliciesActive() {
      return false;
    },
    isAdminSettingsActive() {
      return false;
    },
    organisationName() {
      return this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst() ? this.$store.state.user.organisation?.name : this.$store.state.user.organisation?.organisation;
    },

    organisationLogo() {
      return this.$store.state.user.organisation?.organisation_logo?.logo || this.defaultLogo;
    },

    filteredOrganisations() {
      if (!this.orgSearchTerm) {
        return this.$store.state.user.organisations;
      }
      return this.$store.state.user.organisations.filter((org) =>
        org.name.toLowerCase().includes(this.orgSearchTerm.toLowerCase())
      );
    },

    isDashboardPage() {
      return this.$route.path === '/dashboard';
    },

    isPolicyOwner() {
      return this.$store.state.user.isPolicyOwner;
    }
  },
  methods: {
    trainingAdmin() {
      if (!this.$store.state.user.organisation?.products) return;
      const rawProducts = this.$store.state.user.organisation?.products;
      let products = this.$helper.isVertexAnalyst()
        ? (Array.isArray(rawProducts?.[0]) ? rawProducts[0] : (Array.isArray(rawProducts) ? rawProducts : (this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.products || [])))
        : (Array.isArray(rawProducts) ? rawProducts : []);
      for (const product of products) {
        if (product && product.product === 'cyber_security_online_awareness_training') {
          if (product.roles && product.roles.includes("admin") == true)
            this.isTrainingAdmin = true;
        }
      }
    },

    settingsAdmin() {
      if (!this.$store.state.user.organisation?.products) return;
      const rawProducts = this.$store.state.user.organisation?.products;
      let products = this.$helper.isVertexAnalyst()
        ? (Array.isArray(rawProducts?.[0]) ? rawProducts[0] : (Array.isArray(rawProducts) ? rawProducts : (this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.products || [])))
        : (Array.isArray(rawProducts) ? rawProducts : []);

      for (const product of products) {
        if (!product) continue;
        if (product.product == "cyber_security_online_awareness_training")
          this.hasTraining = true;

        if (product.product == "pentester_platform")
          this.hasPentest = true;

        if (product.product == "automated_test_phishing_campaigns")
          this.hasPhishing = true;

        if (product.product == "policy_management")
          this.hasPolicy = true;

        if (product.product === 'email_compromise_check' || product.product === 'cyber_security_online_awareness_training' || product.product === 'automated_test_phishing_campaigns' || product.product === "pentester_platform" || product.product === "policy_management") {
          if (product.roles && product.roles.includes("admin") == true)
            this.coreAdmin = true;
        }
      }

    },

    showThoughtBubble(event, content) {
      if (this.toggleMainSidebar) return;
      const rect = event.currentTarget.getBoundingClientRect();
      this.thoughtBubble.visible = true;
      this.thoughtBubble.content = content;
      this.thoughtBubble.position = {
        top: `${rect.top}px`,
        left: `${rect.right + 10}px`,
      };
    },
    hideThoughtBubble() {
      this.thoughtBubble.visible = false;
    },
    showTooltipIfTruncated(event) {
      const element = event.currentTarget;
      if (element.scrollWidth > element.clientWidth) {
        element.title = element.innerText;
      } else {
        element.removeAttribute("title");
      }
    },
    handleClickOutside(event) {
      const userContainer = this.$el.querySelector(".user-dropdown-container");
      const userDropdown = this.$el.querySelector(".user-dropdown");
      const orgContainer = this.$el.querySelector(".org-dropdown-container");
      const orgDropdown = this.$el.querySelector(".org-dropdown");

      if (
        (userContainer && userContainer.contains(event.target)) ||
        (userDropdown && userDropdown.contains(event.target)) ||
        (orgContainer && orgContainer.contains(event.target)) ||
        (orgDropdown && orgDropdown.contains(event.target))
      ) {
        return;
      }

      this.userDropdownOpen = false;
      this.orgDropdownOpen = false;
    },
    toggleReportingSubMenu() {
      this.reportingSubMenuOpen = !this.reportingSubMenuOpen;
    },
    toggleTrainingSubMenu() {
      this.trainingSubMenuOpen = !this.trainingSubMenuOpen;
    },
    togglePoliciesSubMenu() {
      this.policiesSubMenuOpen = !this.policiesSubMenuOpen;
    },
    toggleOrgDropdown() {
      const isSuperAdmin = this.$store.state.auth.isSuperAdmin;
      const isVertexAnalystOnDashboard = this.$helper.isVertexAnalyst() && this.isDashboardPage;

      if (!isSuperAdmin && !isVertexAnalystOnDashboard) return;

      this.orgDropdownOpen = !this.orgDropdownOpen;
      this.userDropdownOpen = false;
    },

    async selectOrganisation(org) {
      if (!org) return;
      let organisation = await this.getOrganisation(org.id);
      if (organisation) {
        if (this.$helper.isVertexAnalyst()) {
          const orgRole = this.$store.state.auth.jwtPayload?.organisation_role?.[0];
          organisation.products = orgRole?.products ? [orgRole.products] : (org.products || []);
        } else {
          organisation.products = org.products;
        }
      }
      this.$store.commit("user/setOrganisation", organisation);
      this.orgDropdownOpen = false;
      if (!this.$store.state.auth.isSuperAdmin) {
        this.trainingAdmin();
        this.settingsAdmin();
      }
    },

    async getOrganisation(id) {
      return await this.$axios.get(`/organisations/` + id)
        .then((response) => {
          if (response.data.success) {
            return response.data.organisation;
          } else {
            this.$toast.error(response.data.message);
            return;
          }
        })
        .catch()
    },

    setDefaultOrganisation() {
      let analystOrg = null;
      try {
        const organisationString = localStorage.getItem('userOrganisation');
        analystOrg = organisationString ? JSON.parse(organisationString) : null;
      } catch (e) {
        analystOrg = null;
      }

      const organisations = this.$store.state.user.organisations || [];
      const targetId = analystOrg?.id || this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation_id;
      const targetName = analystOrg?.name;

      let matchedOrg = null;
      if (targetId) {
        matchedOrg = organisations.find(o => o.id == targetId);
      }
      if (!matchedOrg && targetName) {
        matchedOrg = organisations.find(({ name }) => name && name.toLowerCase().includes(targetName.toLowerCase()));
      }

      if (matchedOrg) {
        if (this.$helper.isVertexAnalyst()) {
          const orgRole = this.$store.state.auth.jwtPayload?.organisation_role?.[0];
          matchedOrg.products = orgRole?.products ? [orgRole.products] : (matchedOrg.products || []);
        }
        this.$store.commit("user/setOrganisation", matchedOrg);
        if (!this.$store.state.auth.isSuperAdmin) {
          this.trainingAdmin();
          this.settingsAdmin();
        }
        this.selectOrganisation(matchedOrg);
      }
    },

    toggleUserDropdown() {
      this.userDropdownOpen = !this.userDropdownOpen;
      this.orgDropdownOpen = false;
    },

    logout() {
      const userId = this.$store.state.auth.jwtPayload?.user_id;
      const completeLogout = () => {
        localStorage.setItem('currentUrl', null);
        this.$store.dispatch('auth/logout', { logoutAuth: true });
      };

      if (userId) {
        this.$axios
          .post(`/users/${userId}/logout`, null, { skipAuthRefresh: true })
          .catch(() => {})
          .finally(completeLogout);
      } else {
        completeLogout();
      }
    },

    profileURL() {
      window.open(process.env.VUE_APP_AUTH_BASE_URL + '/user-settings/', '_blank');
    },

    orgSettings() {
      if (this.$store.state.auth.accessToken == null) return

      window.open(process.env.VUE_APP_AUTH_BASE_URL + '/organisations/' + this.organisationID + '/settings', '_blank');
    },

    toggleSidebar() {
      this.toggleMainSidebar = !this.toggleMainSidebar;
      this.isSidebarManuallyToggled = true;
      if (window.innerWidth <= 768) {
        this.isBackdropActive = this.toggleMainSidebar;
      }
    },

    closeSidebar() {
      this.toggleMainSidebar = false;
      this.isBackdropActive = false;
    },

    onResize() {
      if (window.innerWidth > 768) {
        this.isBackdropActive = false;
      }

      if (this.isSidebarManuallyToggled) {
        return;
      }

      if (window.innerWidth < 992) {
        this.toggleMainSidebar = false;
      } else {
        this.toggleMainSidebar = true;
      }
    },
  },
  watch: {
    $route(to) {
      if (this.$helper.isVertexAnalyst() && to.path !== '/dashboard') {
        let analystOrg = null;
        try {
          const organisationString = localStorage.getItem('userOrganisation');
          analystOrg = organisationString ? JSON.parse(organisationString) : null;
        } catch (e) {
          analystOrg = null;
        }
        const targetId = analystOrg?.id || this.$store.state.auth.jwtPayload?.organisation_role?.[0]?.organisation_id;
        if (targetId && this.organisationID != targetId) {
          this.setDefaultOrganisation();
        }
      }
    },
    toggleMainSidebar(newVal) {
      this.$emit("sidebar-toggled", newVal);
    },
    orgDropdownOpen(newVal) {
      if (this.$store.state.auth.isSuperAdmin || this.$helper.isVertexAnalyst()) {
        this.getOrganisation(this.organisationID);
      }

      if (newVal) {
        this.$nextTick(() => {
          this.$refs.orgSearchInput.focus();
        });
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.main-sidebar-container {
  background: #435666;
  height: 100vh;
  height: 100dvh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 70px;
  max-width: 70px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow: visible;
}

.main-sidebar-container.expanded {
  width: 260px;
  max-width: 260px;
}

.sidebar {
  width: 100%;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Logo Section */
.logo-section {
  padding: 20px;
  border-bottom: 1px solid rgba(163, 192, 209, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
  flex-shrink: 0;
}

.logo-img {
  width: 48px;
  height: 48px;
  border-radius: 8px;
}

.logo-text {
  margin-left: 12px;
  color: white;
  font-size: 18px;
  font-weight: 600;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
}

.main-sidebar-container.expanded .logo-text {
  opacity: 1;
  transform: translateX(0);
}

/* Navigation Menu */
.nav-menu-wrapper {
  flex: 1;
  min-height: 0;
  padding: 20px 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
}

.nav-menu-list {
  list-style: none;
  padding: 0 10px;
  margin: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.nav-menu-item {
  margin-bottom: 4px;
  width: 100%;
  max-width: 100%;
}

.nav-menu-link,
.submenu-link {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  color: #a3c0d1;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.nav-menu-link:hover,
.submenu-link:hover {
  background-color: rgba(163, 192, 209, 0.1);
  color: #fff;
  transform: translateX(2px);
}

.nav-menu-link.active,
.submenu-link.active {
  background: linear-gradient(135deg, #00a0c1, #0088a3);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 160, 193, 0.3);
}

.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.menu-icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.menu-label {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  white-space: nowrap;
}

.main-sidebar-container.expanded .menu-label {
  opacity: 1;
  transform: translateX(0);
}

/* Improved Toggle Button */
.toggle-bar {
  position: fixed;
  left: 52px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1001;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle-bar.expanded {
  left: 242px;
}

.toggle-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #00a0c1, #0088a3);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 160, 193, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
}

.toggle-menu-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 160, 193, 0.4);
}

.toggle-menu-btn:active {
  transform: scale(0.95);
}

/* Animated hamburger icon */
.hamburger-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hamburger-icon svg {
  width: 20px;
  height: 20px;
  color: white;
}

/* Account section */
.account-menu-wrapper {
  padding: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 1px solid rgba(163, 192, 209, 0.2);
  transition: padding 0.3s ease;
}

.main-sidebar-container:not(.expanded) .account-menu-wrapper {
  padding: 5px 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  color: #a3c0d1;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.user-info:hover {
  background-color: rgba(163, 192, 209, 0.1);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00a0c1, #0088a3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.user-name {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.main-sidebar-container.expanded .user-name {
  opacity: 1;
  transform: translateX(0);
}

/* Organisation Info section */
.org-info-wrapper {
  padding: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 1px solid rgba(163, 192, 209, 0.2);
  transition: padding 0.3s ease;
}

.main-sidebar-container:not(.expanded) .org-info-wrapper {
  padding: 20px 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.org-info {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  color: #a3c0d1;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.org-info.non-interactive {
  cursor: default;
}

.org-info:hover {
  background-color: rgba(163, 192, 209, 0.1);
}

.org-logo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  background-color: #ffffff;
}

.org-logo img {
  width: 100%;
  height: 100%;
  /* CHANGE THIS: 'cover' zooms the image to fill the circle */
  object-fit: cover;
}

.org-name {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main-sidebar-container.expanded .org-name {
  opacity: 1;
  transform: translateX(0);
}

/* Backdrop for mobile */
.sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.sidebar-backdrop.active {
  opacity: 1;
  visibility: visible;
}

/* Responsive design */
@media (max-width: 768px) {
  .main-sidebar-container {
    transform: translateX(-100%);
    width: 260px;
    max-width: 260px;
    box-shadow: none;
  }

  .main-sidebar-container.expanded {
    transform: translateX(0);
    box-shadow: 10px 0 30px rgba(0, 0, 0, 0.3);
  }

  .sidebar {
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .nav-menu-wrapper {
    flex: 1 0 auto;
    overflow-y: visible;
  }

  .user-dropdown-container {
    padding-bottom: env(safe-area-inset-bottom, 16px);
  }

  .main-sidebar-container.expanded~.org-dropdown,
  .main-sidebar-container.expanded~.user-dropdown {
    left: 10px;
    width: 240px;
    z-index: 1003;
  }

  .user-dropdown {
    bottom: 80px;
  }

  .org-dropdown {
    bottom: 145px;
    max-height: 240px;
  }

  .toggle-bar {
    position: fixed;
    left: 15px;
    top: 15px;
    transform: none;
    z-index: 1002;
  }

  .toggle-bar.expanded {
    left: 215px;
    top: 15px;
  }

  .logo-text,
  .menu-label,
  .user-name {
    opacity: 1;
    transform: translateX(0);
  }
}

.submenu {
  list-style: none;
  padding-left: 20px;
}

.main-sidebar-container:not(.expanded) .submenu {
  padding-left: 0;
}

.submenu-item {
  margin-bottom: 4px;
}

.nav-menu-link-container {
  position: relative;
}

.submenu-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #a3c0d1;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.submenu-arrow.rotated {
  transform: translateY(-50%) rotate(180deg);
}

@media (max-width: 768px) {

  .nav-menu-link::before,
  .nav-menu-link::after {
    display: none;
  }
}

/* Organisation Dropdown */
.org-dropdown-container {
  position: relative;
  flex-shrink: 0;
}

.org-info {
  position: relative;
}

.org-info .submenu-arrow {
  right: 20px;
}

.org-dropdown,
.user-dropdown {
  position: fixed;
  width: 240px;
  background: #3a4b59;
  border-radius: 10px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.org-dropdown {
  bottom: 80px;
  max-height: 300px;
  overflow-y: auto;
}

.user-dropdown {
  bottom: 20px;
}

.main-sidebar-container.expanded~.org-dropdown,
.main-sidebar-container.expanded~.user-dropdown {
  left: 270px;
}

.main-sidebar-container:not(.expanded)~.org-dropdown,
.main-sidebar-container:not(.expanded)~.user-dropdown {
  left: 80px;
}

/* Reduce submenu icon size when collapsed */
.main-sidebar-container:not(.expanded) .submenu .menu-icon {
  width: 22px;
  height: 22px;
}

.main-sidebar-container:not(.expanded) .submenu .menu-icon svg {
  width: 18.38px;
  height: 18.38px;
}

/* Adjust padding for active submenu items when collapsed */
.main-sidebar-container:not(.expanded) .submenu-link.active {
  margin-left: 5px;
  margin-right: 5px;
  width: auto;
}

.search-bar {
  padding: 10px;
  border-bottom: 1px solid rgba(163, 192, 209, 0.2);
}

.search-bar input {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #435666;
  background: #2d3748;
  color: #a3c0d1;
  outline: none;
}

.org-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.org-list li {
  padding: 12px 20px;
  color: #a3c0d1;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.org-list li:hover {
  background-color: rgba(163, 192, 209, 0.1);
  color: #fff;
}

/* User Dropdown */
.user-dropdown-container {
  position: relative;
  flex-shrink: 0;
}

.user-info {
  position: relative;
}

.user-info .submenu-arrow {
  right: 20px;
}

.user-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.user-menu-list li {
  padding: 12px 20px;
  color: #a3c0d1;
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-menu-list li:hover {
  background-color: rgba(163, 192, 209, 0.1);
  color: #fff;
}

.user-menu-list li.disabled {
  color: #6b7280;
  cursor: not-allowed;
}

.user-menu-list li.disabled:hover {
  background-color: transparent;
  color: #6b7280;
}

/* Adjust layout for collapsed sidebar to prevent icon/arrow overlap */

/* Make all item containers 70px wide */
.main-sidebar-container:not(.expanded) .nav-menu-list,
.main-sidebar-container:not(.expanded) .account-menu-wrapper,
.main-sidebar-container:not(.expanded) .org-info-wrapper {
  padding-left: 0;
  padding-right: 0;
}

/* Standardize padding on the items themselves.
   This gives 50px content width (70px - 2*10px). */
.main-sidebar-container:not(.expanded) .nav-menu-link,
.main-sidebar-container:not(.expanded) .submenu-link,
.main-sidebar-container:not(.expanded) .user-info,
.main-sidebar-container:not(.expanded) .org-info {
  justify-content: center;
  padding: 12px 10px;
}

.main-sidebar-container:not(.expanded) .org-name,
.main-sidebar-container:not(.expanded) .user-name,
.main-sidebar-container:not(.expanded) .menu-label {
  display: none;
}

/* Position the arrow consistently. */
.main-sidebar-container:not(.expanded) .submenu-arrow {
  right: 4px;
}

/* Explicitly override for user/org info to ensure consistency */
.main-sidebar-container:not(.expanded) .org-info .submenu-arrow,
.main-sidebar-container:not(.expanded) .user-info .submenu-arrow {
  right: 4px !important;
}
</style>
